/* unplugin-vue-components disabled */import { ElPagination as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  "class": "index_container__pOVDp margin-t",
  "element-loading-text": "数据加载中"
};
var _hoisted_2 = {
  "class": "index_articleListWrapper__gfxr8"
};
var _hoisted_3 = {
  "class": "index_articleList__tWiD3"
};
var _hoisted_4 = {
  "class": "index_item__VizbC"
};
var _hoisted_5 = {
  "class": "index_itemImg__Ty3XC"
};
var _hoisted_6 = ["title"];
var _hoisted_7 = ["src", "alt"];
var _hoisted_8 = ["title", "textContent"];
var _hoisted_9 = {
  "class": "index_itemContent__vdhzX"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["textContent"];
var _hoisted_12 = {
  "class": "index_itemExcerpt__Lj3te"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
  "class": "index_itemMeta__l_gaX"
};
var _hoisted_15 = ["textContent"];
var _hoisted_16 = {
  "class": "center-div",
  style: {}
};
var _hoisted_17 = {
  "class": "index_articleRec__LaNJG"
};
var _hoisted_18 = {
  "class": "index_widget__gspQW index_widget_recent__24nWU"
};
var _hoisted_19 = ["onClick", "textContent"];
var _hoisted_20 = {
  "class": "index_widget__gspQW index_widget_recent__24nWU"
};
var _hoisted_21 = ["onClick", "textContent"];
import { newsListApi, hotNewsApi } from '@/api/activi';
export default /*@__PURE__*/_defineComponent({
  __name: 'News',
  setup: function setup(__props) {
    var newsData = ref([{
      id: '',
      name: '',
      context: '',
      createTime: '',
      image: ''
    }]);
    var currentPage = ref(1);
    var newParam = ref({
      pageNum: currentPage.value,
      pageSize: 10,
      type: 0,
      hotspot: ''
    });
    var hotNewsParam = ref({
      pageNum: 1,
      pageSize: 5,
      hotspot: 1,
      type: 0
    });
    var hotNewsData = ref([{
      id: '',
      name: '',
      context: '',
      createTime: '',
      image: ''
    }]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, _response$data$record, _response$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getNewsList();
            _context.next = 3;
            return hotNewsApi(hotNewsParam.value);
          case 3:
            response = _context.sent;
            if (response.code === 200) {
              hotNewsData.value = (_response$data$record = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.records) !== null && _response$data$record !== void 0 ? _response$data$record : [];
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var total = ref(0);
    function getNewsList() {
      return _getNewsList.apply(this, arguments);
    }
    function _getNewsList() {
      _getNewsList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$records, _res$data, _res$data$total, _res$data2, _res$data$current, _res$data3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return newsListApi(newParam.value);
            case 2:
              res = _context2.sent;
              if (res.code == 200) {
                newsData.value = (_res$data$records = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.records) !== null && _res$data$records !== void 0 ? _res$data$records : [];
                total.value = (_res$data$total = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) !== null && _res$data$total !== void 0 ? _res$data$total : 0;
                currentPage.value = (_res$data$current = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.current) !== null && _res$data$current !== void 0 ? _res$data$current : 1;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _getNewsList.apply(this, arguments);
    }
    function handelCurrentChange(pageNum) {
      newParam.value.pageNum = pageNum;
      getNewsList();
    }
    var router = useRouter();
    function clickItem(id) {
      router.push("/newItem/".concat(id));
    }
    return function (_ctx, _cache) {
      var _component_el_pagination = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("ul", {
        "class": "index_tabsNav___H_94"
      }, [_createElementVNode("a", {
        href: "/article"
      }, [_createElementVNode("li", {
        "class": "index_active__1x0Kq"
      }, "全部")])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
          title: item.name
        }, [_createElementVNode("img", {
          src: item.image,
          alt: item.name
        }, null, 8, _hoisted_7)], 8, _hoisted_6), _createElementVNode("div", {
          "class": "index_itemImgDes__JMjb8",
          title: item.name,
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("h2", {
          "class": "index_itemTitle__srbn3",
          onClick: function onClick($event) {
            return clickItem(item.id);
          }
        }, [_createElementVNode("a", {
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_11)], 8, _hoisted_10), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", {
          innerHTML: item.context
        }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", {
          textContent: _toDisplayString(item.createTime)
        }, null, 8, _hoisted_15), _cache[1] || (_cache[1] = _createElementVNode("span", {
          "class": "index_pageView__djDrK"
        }, [_createElementVNode("span", {
          role: "img",
          "class": "anticon"
        }, [_createElementVNode("svg", {
          "class": "",
          viewBox: "0 0 1024 1024",
          xmlns: "http://www.w3.org/2000/svg",
          width: "1em",
          height: "1em",
          fill: "currentColor",
          "aria-hidden": "true",
          focusable: "false"
        }, [_createElementVNode("path", {
          d: "M512.173 795c171.39 0 318.422-118.888 356.196-283.157C830.477 347.727 683.517 229 512.245 229c-171.39 0-318.422 118.888-356.197 283.157C193.941 676.273 340.9 795 512.173 795zM75.93 504.096C118.297 298.658 299.91 149 512.245 149c212.19 0 393.717 149.458 436.234 354.712a40 40 0 0 1 .007 16.192C906.121 725.342 724.507 875 512.173 875c-212.191 0-393.718-149.458-436.235-354.712a40 40 0 0 1-.007-16.192zM512 704c-106.039 0-192-85.961-192-192s85.961-192 192-192 192 85.961 192 192-85.961 192-192 192zm0-80c61.856 0 112-50.144 112-112s-50.144-112-112-112-112 50.144-112 112 50.144 112 112 112z",
          fill: "#7a7a7a"
        })])])], -1))])])])]);
      }), 128))]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        "current-page": _unref(currentPage),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(currentPage) ? currentPage.value = $event : null;
        }),
        onCurrentChange: handelCurrentChange,
        total: _unref(total)
      }, null, 8, ["current-page", "total"])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[2] || (_cache[2] = _createElementVNode("h3", null, "近期活动", -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("a", {
          rel: "",
          onClick: function onClick($event) {
            return clickItem(item.id);
          },
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_19)]);
      }), 128))])]), _createElementVNode("div", _hoisted_20, [_cache[3] || (_cache[3] = _createElementVNode("h3", null, "热门活动", -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hotNewsData), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("a", {
          rel: "",
          onClick: function onClick($event) {
            return clickItem(item.id);
          },
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_21)]);
      }), 128))])])])])]);
    };
  }
});